module.exports = __webpack_public_path__ + "static/media/ComputerTalk_Step3_Image1.147fae02.jpg";